/**
 * Navigation Configuration
 *
 * Shared navigation items used by the sidebar and command palette.
 */

import {
  Home,
  Package,
  Palette,
  KeyRound,
  Shield,
  Globe,
  Activity,
} from 'lucide-react'

export type NavItem = {
  label: string
  href: string
  icon: React.ComponentType<{ className?: string }>
}

export type NavGroup = {
  label?: string
  items: NavItem[]
}

export const navGroups: NavGroup[] = [
  // Dashboard - standalone
  {
    items: [
      {
        label: 'Dashboard',
        href: '/dashboard',
        icon: Home,
      },
    ],
  },

  // Plugin Ecosystem group
  {
    label: 'Plugin Ecosystem',
    items: [
      {
        label: 'Plugins',
        href: '/dashboard/plugins',
        icon: Package,
      },
      {
        label: 'Themes',
        href: '/dashboard/themes',
        icon: Palette,
      },
      {
        label: 'Licenses',
        href: '/dashboard/licenses',
        icon: KeyRound,
      },
      {
        label: 'OAuth Sites',
        href: '/dashboard/jezpress',
        icon: Shield,
      },
    ],
  },

  // Fleet group
  {
    label: 'Fleet',
    items: [
      {
        label: 'Sites',
        href: '/dashboard/sites',
        icon: Globe,
      },
    ],
  },

  // Tools group
  {
    label: 'Tools',
    items: [
      {
        label: 'Logs',
        href: '/dashboard/logs',
        icon: Activity,
      },
    ],
  },
]
